export default function (array, f) {
  var i = -1,
      n = array.length,
      a,
      b;

  if (f == null) {
    while (++i < n) {
      if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
    }

    while (++i < n) {
      if ((b = array[i]) != null && b > a) a = b;
    }
  } else {
    while (++i < n) {
      if ((b = f(array[i], i, array)) != null && b >= b) {
        a = b;
        break;
      }
    }

    while (++i < n) {
      if ((b = f(array[i], i, array)) != null && b > a) a = b;
    }
  }

  return a;
}